import "./styles/Bulkpaymentreviewskeleton.scss";

interface CardListSkeletonProps {
  shouldShowTabs?: boolean;
}

const CardListSkeleton = ({ shouldShowTabs = true }: CardListSkeletonProps) => {
  return (
    <div className="gx-skeleton-card-list-container">
      {/* Tabs Skeleton */}
      {shouldShowTabs && (
        <div className="gx-skeleton-card-list-tabs">
          <div className="gx-skeleton gx-skeleton-card-list-tab" />
          <div className="gx-skeleton gx-skeleton-card-list-tab" />
          <div className="gx-skeleton gx-skeleton-card-list-tab" />
        </div>
      )}

      {/* Cards Skeleton */}
      {[1, 2, 3].map((i) => (
        <div key={i} className="gx-skeleton-payment-card">
          <div className="gx-skeleton-payment-card-header">
            <div className="gx-skeleton gx-skeleton-card-title" />
            <div className="gx-skeleton gx-skeleton-card-subtitle" />
            <div className="gx-skeleton gx-skeleton-card-amount" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default CardListSkeleton;